import type { PredictionMarketCardConfig, Security } from '@talos/kyoko';
import type { PredictionRefDataIndexes } from './predictionRefDataIndexes';

export function predictionCardHasRefData(
  card: PredictionMarketCardConfig,
  predictionOutcomesBySymbol: Map<string, Security>,
  indexes: PredictionRefDataIndexes
): boolean {
  if (card.outcomeSymbol) {
    return predictionOutcomesBySymbol.has(card.outcomeSymbol);
  }
  if (indexes.outcomeIndexByEventID.has(card.eventID)) {
    return true;
  }
  // Cards persist whatever identified the event when they were saved, which may be its symbol.
  const eventID = indexes.eventIDByEventSymbol.get(card.eventSymbol) ?? indexes.eventIDByEventSymbol.get(card.eventID);
  return eventID != null && indexes.outcomeIndexByEventID.has(eventID);
}
